import React, { useState, useEffect } from 'react';
import Widgets from './Widgets.js'
import WidgetsAll from './WidgetAll.js'
//import MobilePreview from './MobilePreview';
//import TabletPreview from './TabletPreview';
//import TabletPreviewLands from './TabletPreviewLands';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import ForestIcon from '@mui/icons-material/Forest';
import StarsIcon from '@mui/icons-material/Stars';
import DeviceView from './DeviceView.js';
import RootWrapper from './RootWrapper.js';
import OpenModal from './snippet/OpenModal.js';
import { Button } from "@mui/material";
import RandomProducts from './snippet/RandomProducts.js';

function AppTheme({activeFont: propActiveFont, activeTheme: propActiveTheme, clientName, CustomFont, ThemeList, brandColor,listLanguage,seasonBrand, SeasonList}){
  const location = useLocation();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const {simpleClient, simpleTheme} = useParams();  
  const [selectedLayout, setSelectedLayout] = useState('layout-featured');
  const [ProductCount, setProductCount] = useState(3);
  const [selectedSize, setselectedSize] = useState('size-featured');
  const [modalOpen, setmodalOpen] = useState(false);
  const [modalData, setModalData] = useState({ title: "", content: "", HtmlPath: ""});
  const [activeTheme, setActiveTheme] = useState(propActiveTheme || 'yellow');  
  const themes = ThemeList.split(',');
  const seasons = SeasonList.split(',');
  const [selectedLanguage, setSelectedLanguage] = useState('english');
  const [selectedFont, setSelectedFont] = useState('fira');
  const [seasonOption, setSeasonOption] = useState(0);
  const [seasonOptionIndex, setSeasonOptionIndex] = useState(1);
  const [selectedStore, setSelectedStore] = useState('');
  
  const ThemeIcons = [
    'yellow:#FFA100',     
    'green:#009a61', 
    'green_old:#437B00', 
    'blue:#005E80', 
    'red:#bd0009', 
    'maroon:#88004A', 
    'gray:#bbbbbb', 
    'black:#000000',     
    'lego:#FFED00',     
    'warhammer:#fbca1b',     
    'printer'];//['christmas', 'ads', 'blackfriday','diwali', 'thanks'];
    const seasonLabels = {
      brand_christmas: 'Christmas',
      brand_ads: 'Advertising',
      brand_diwali: 'Diwali',
      brand_blackfriday: 'Black Friday',      
      brand_thanks: 'Thanks Giving',
      brand_newyear: 'New Year',
      /* brand_christmas: 'Christmas - 25 Dec',
      brand_ads: 'Advertising - Feb 14',
      brand_diwali: 'Diwali - 12 Nov',
      brand_blackfriday: 'Black Friday - 28 Nov',      
      brand_thanks: 'Thanks Giving - 27 Nov', */
    };    
  const IconConfig = ThemeIcons.reduce((config, themeItem) => {
    const [themeName, colorValue] = themeItem.split(':');
    const brandName = `brand_${themeName}`;
    if (colorValue) {
      config[themeName] = { backgroundColor: colorValue };
      //config[brandName] = { backgroundColor: colorValue };
    } else {
      // Handle image-based themes
      const themeStyle = {
        backgroundImage: `url("/scss/themes/assets/images/season/icon-${themeName}.png")`,
        backgroundPosition: 'center',backgroundSize: '100%',
        //display: (themeName === 'XXchristmas' || themeName === 'XXthanks') && typeof selectedLanguage !== 'undefined' && selectedLanguage === 'arabic' ? 'none' : undefined,
      };
      config[themeName] = themeStyle;
      config[brandName] = themeStyle;
    }  
    return config;
  }, {});
  
  const openFeedbackModal = () => {
    setModalData({ title: "Rate Your Purchase!", content: "" });
    setmodalOpen(true);
  };
 
  
  const navigate = useNavigate();
  const pathArgument = location.pathname.split('/'); 
  const isPathArgumentEmpty = 'show';
  const handleLayoutChange = (event) => {setSelectedLayout(event.target.value);};
  const handleSizeChange = (event) => {setselectedSize(event.target.value);};
  const [isSettingOpen, setIsSettingOpen] = useState(true);
  const toggleSetting = () => {setIsSettingOpen(!isSettingOpen);};
  const [selectedDevice, setselectedDevice] = useState('desktop');
  const [carbon, setCarbon] = useState(1);
  const [isCarbonActive, setIsCarbonActive] = useState(true);
  const [rating, setRating] = useState(1);
  const [isRatingActive, setIsRatingActive] = useState(true);
  
  const handleRatingClick = () => {
    setIsRatingActive(prev => !prev);
    setRating(prev => (prev === 0 ? 1 : 0));
  };



  const themeChange = (theme) => {
    document.body.classList.remove(`theme-${activeTheme}`);
    document.body.classList.forEach(c => c.startsWith("theme-") && document.body.classList.remove(c));
    setActiveTheme(theme);
    //document.body.classList.add(`theme-${theme}`);
    //console.log(`Clicked on ${theme} button`);
    if (theme.startsWith('brand_')) {setSelectedSeason(theme);} else {setSelectedSeason(''); }      
};
  const handleDeviceChange = (event) => {
    setselectedDevice(event.target.value);
    setSelectedLayout(event.target.value);
    if (event.target.value === "layout-print") {
      const url = `/iniframe?color=${activeTheme}&language=${selectedLanguage}&clientName=${clientName}&layout=${selectedLayout}&font=${selectedFont}&carbon=${carbon}&rating=${rating}&addcss=${selectedLayout}&mode=&brandColor=${brandColor}&seasonBrand=${seasonBrand}&ProductCount=${ProductCount}&print=layout-print`;
      window.open(url, "_blank");
    }
  };
  const handleProductCount = (e) => {
    setProductCount(e.target.value);    
  };
  const [selectedSeason, setSelectedSeason] = useState('');

  useEffect(() => {    
    if (["desktop", "tablet", "tablet-landscape", "mobile"].includes(selectedDevice)) {setSelectedLayout("layout-featured");}
  }, [selectedDevice]);
  useEffect(() => { if (selectedFont=="none") {setSelectedFont("fira");}}, [selectedFont]);
  useEffect(() => { if (selectedLanguage=="") {setSelectedLanguage("english");}}, [selectedLanguage]);
  useEffect(() => { if (selectedStore=="") {setSelectedStore("fashion");}}, [selectedStore]);
  useEffect(() => {
    if (!activeTheme || !seasonOption || !seasonOptionIndex) return;  
    const base = activeTheme.replace('brand_', '');
    const classes = [`theme-${base}`,`theme-${activeTheme}${seasonOptionIndex}`,];  
    document.body.classList.add(...classes);  
    return () => {document.body.classList.remove(...classes); };
  }, [seasonOption, seasonOptionIndex]);

  useEffect(() => {    
    if(activeTheme=='empty'){      
      setSeasonOption(0);setSeasonOptionIndex(0);
      setActiveTheme('yellow'); 
      if(brandColor){setActiveTheme(brandColor);}      
    }
  }, [activeTheme]);

  useEffect(() => {
    switch (activeTheme) {
      case 'brand_christmas': setSeasonOption(3); setSeasonOptionIndex(1);break;
      case 'brand_thanks': setSeasonOption(3); setSeasonOptionIndex(1);break;
      case 'brand_ads': setSeasonOption(3); setSeasonOptionIndex(1);break;
      case 'brand_diwali': setSeasonOption(5); setSeasonOptionIndex(1);break;
      case 'brand_blackfriday': setSeasonOption(3); setSeasonOptionIndex(1);break;
      case 'brand_newyear': setSeasonOption(3); setSeasonOptionIndex(1);break;
      // Add more cases as needed
      default: setSeasonOption(0);setSeasonOptionIndex(0);
    }
  }, [activeTheme]);
 
  const renderSelectedComponent = () => {
    switch (selectedDevice) { 
    case 'mobile':
      return <DeviceView deviceName='mobile' deviceWidth='330' deviceHeight='625' activeTheme={activeTheme} clientName={clientName} font={selectedFont} language={selectedLanguage}  addcss={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'tablet':
      return <DeviceView deviceName='tablet' deviceWidth='600' deviceHeight='960' activeTheme={activeTheme} clientName={clientName} font={selectedFont} language={selectedLanguage}  addcss={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'tablet-landscape':
      return <DeviceView deviceName='tablet tablet-landscape' deviceWidth='960' deviceHeight='600' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  addcss={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'desktop':case "none":case "layout-featured":
      return <RootWrapper activeTheme={activeTheme} clientName={clientName} font={selectedFont} language={selectedLanguage} setActiveTheme={setActiveTheme}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'layout-pdf': 
      return <DeviceView deviceName='mobilex' deviceWidth='700' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'layout-a4print': 
      return <DeviceView deviceName='mobilex' deviceWidth='700' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'layout-a5print': 
      return <DeviceView deviceName='mobilex' deviceWidth='420' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'layout-a6print': 
      return <DeviceView deviceName='mobilex' deviceWidth='315' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'layout-full':
      return <DeviceView deviceName='mobilex' deviceWidth='700' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;      
    case 'layout-simple':
      return <DeviceView deviceName='mobilex' deviceWidth='700' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;      
    case 'layout-small':
      return <DeviceView deviceName='mobilex' deviceWidth='420' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;
    case 'layout-bill':
      return <DeviceView deviceName='mobilex' deviceWidth='300' deviceHeight='850' activeTheme={activeTheme} clientName={clientName}  font={selectedFont} language={selectedLanguage}  selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} />;        
    default:
      return null;
    }
  };  



const handleCarbonClick = () => {
  setIsCarbonActive(prev => !prev);
  setCarbon(prev => (prev === 0 ? 1 : 0));

  document.querySelectorAll("td.carbon.highlight").forEach(td => {
    td.style.backgroundColor = "#4eff4e"; 
    td.style.transition = "background-color 1s ease-in-out";
    setTimeout(() => {
      td.style.backgroundColor = "";
    }, 1000);
  });
};

const handleSelectLanguage = (event) => {
  setSelectedLanguage(event.target.value); 
};
const handleSelectFont = (event) => {  
  setSelectedFont(event.target.value);
}

const handleSelectStore = (e) => {
  const url = e.target.value;
  setSelectedStore(url); // Update state
  if (url) {
    window.location.assign(url); // Force redirect even if same value as before
  }
};
useEffect(() => {
 const currentPath = window.location.pathname;
  const parts = currentPath.split("-");
  const storeId = parts[parts.length - 1]; // e.g. "183db8bc4fbb"
  if (parts[0]='/view/508587d1') { if (storeId) {setSelectedStore(`/view/508587d1-347c-46c3-9f45-${storeId}`);
  }}
  if (CustomFont) {setSelectedFont(CustomFont);}
}, []);

  return (
    <div>
    <style>{`
    ${(selectedLayout?.startsWith("layout-") || selectedDevice === "mobile" || selectedDevice === "tablet" || selectedDevice === "tablet-landscape") &&
      selectedLayout !== "layout-featured" ? `
    body#body-root {
      background-color: #404040 !important;
      background-image: none !important;
    }` : ""}  
  ${selectedLayout?.startsWith("layout-") && selectedLayout !== "layout-featured" ? `
    iframe {
      height: calc(100vh - 60px);
    }
  ` : ""}`}
  </style>
        <div className='wrapper'>
              {renderSelectedComponent()}
              <div id="setting" dir='ltr' className={`hide-in-pdf font-arial d-lg-block setting-sticky invoice-wrap1 text-center p-1 ${isSettingOpen ? 'open' : ''}`}>
              <div>                  
                  <span id='setting-btn' onClick={toggleSetting}>
                        <span className={`${isSettingOpen ? 'd-none' : ''}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" /></svg>
                        </span>
                        <span className={`${isSettingOpen ? '' : 'd-none'}`}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M15.4,16.6L10.8,12L15.4,7.4L14,6L8,12L14,18L15.4,16.6Z" /></svg>
                        </span>
                  </span>
                  <h3 className='h2 d-lg-none text-white fw-normal mb-2'>Settings : </h3>              
                  {listLanguage && listLanguage.split(',').length > 1 && (
                    <div className='d-block d-md-inline-block me-1 mb-2 mb-lg-0'>
                      <select 
                        value={selectedLanguage} 
                        onChange={handleSelectLanguage} 
                        style={{ padding: '0.5em 0', borderRadius: '0' }}
                      >  
                        <option value="">- Language -</option> 
                        {listLanguage.split(',').map((lang) => (
                          <option key={lang.toLowerCase()} value={lang.toLowerCase()}>
                            {lang}
                          </option>
                        ))}
                      </select> 
                    </div>
                  )}

                <div className='d-block d-md-inline-block me-1 mb-2 mb-lg-0'>
                <select value={selectedFont} onChange={handleSelectFont} style={{ padding: '0.5em 0', borderRadius: '0'}} className={`${selectedLanguage === 'arabic' ? 'opacity-25' : ''}`}>   
                          <>                          
                          <option value="none">- Fonts -</option>
                          <option value="fira">Fira Sans (Default)</option>
                          <option value="nunito">Nunito Sans</option>
                          <option value="open">Open Sans</option>
                          <option value="lato">Lato</option>
                          <option value="poppins">Poppins</option>
                          <option value="montserrat">Montserrat</option>
                          <option value="raleway">Raleway</option>
                          <option value="ubuntu">Ubuntu</option>
                          <option value="playfair">Playfair Display</option>
                          <option value="merriweather">Merriweather</option>
                          <option value="source">Source Sans Pro</option>
                          <option value="hm">HM Slussen</option>
                          <option value="cera">Cera Pro</option>
                          <option value="bitter">Bitter</option>
                          </>                    
                  </select> 
                </div>


                <div className={`d-block d-md-inline-block`}>
                <select value={selectedDevice} onChange={handleDeviceChange} style={{ padding: '0.5em 0', borderRadius: '0' }} disabledx={selectedLanguage !== 'english'}>                                                  
                        
                        <option value="none">Device:</option>
                        <option value="desktop">- Desktop</option>
                        <option value="tablet">- Tablet Portrait</option>
                        <option value="tablet-landscape">- Tablet Landscape</option>
                        <option value="mobile">- Mobile</option>
                        
                        <option value="none">------------------------</option> 

                        <option value="none">Layout :</option>                                         
                        <option value="layout-full">- Full Layout (A4)</option>                                         
                        <option value="layout-simple">- Simple Layout (A4)</option>
                        <option value="layout-small">- Small Layout (A5)</option>                      
                        <option value="layout-bill">- Bill Layout (A6)</option>

                        <option value="none">------------------------</option> 

                        <option value="layout-pdf"> - PDF Preview</option>       

                        <option value="none">------------------------</option> 

                        <option value="none">Print Preview:</option>   
                        <option value="layout-a4print">- A4 Print Preview </option>                        
                        <option value="layout-a5print">- A5 Print Preview</option>   
                        <option value="layout-a6print">- A6 Print Preview</option>  

                        <option value="none">------------------------</option>   

                        <option value="none">Print:</option>                        
                        <option value="layout-print">- A4 or A5 or A6</option>    

                                             
                  </select> 
                </div>
                <div className='d-block d-md-none'><br/></div>                  
                  {isPathArgumentEmpty &&(                 
                      //temporary-neelan-testing
                      <div className='d-block d-md-inline-block mb-2 mb-lg-0' style={{ display: selectedLanguage !== 'english' ? 'nonex' : '' }}>
                      <div class='flex-center bg-white rounded ms-1 text-black' style={{backgroundColor:'#ffffff', padding:'0.2em 1em'}}>
                          <span>Theme:</span>
                          <span>                       
                              {themes.map((theme) => 
                                  IconConfig[theme] ? (
                                      <span 
                                          key={theme} 
                                          className={`theme-btn ${activeTheme === theme ? 'active' : ''}`} 
                                          style={IconConfig[theme]} 
                                          onClick={() => themeChange(theme)}
                                      ></span>
                                  ) : null
                              )}
                          </span>  
                          <span>
                          <select
                              value={selectedSeason}
                              onChange={(e) => {
                                const value = e.target.value;
                                setSelectedSeason(value);
                                themeChange(value);
                              }}
                              className='ms-1'
                              style={{ padding: '0.5em 0', borderRadius: '0' }}
                            >
                              <option value='empty' key=''>- Season -</option>
                              {seasons.map((season) => (
                                <option value={season} key={season}>
                                  {seasonLabels[season] || season}
                                </option>
                              ))}
                            </select>
                        </span>
                        {selectedLayout === "layout-featured" && (<>
                        {[...Array(seasonOption)].map((_, i) => (
                              <span
                                key={i}
                                onClick={() => setSeasonOptionIndex(i + 1)}
                                className={`ms-1 me-0 text-white ${seasonOptionIndex === i + 1 ? "active" : ""}`}
                                style={{
                                  backgroundColor: seasonOptionIndex === i + 1 ? "#001d34" : "#0094ff",
                                  marginRight: 0,
                                  padding: "7px 10px",
                                  cursor: "pointer",
                                  //border: seasonOptionIndex === i + 1 ? "2px solid black" : "2px solid white",
                                  borderRadius: 4,
                                }}
                              >
                                {i + 1}
                              </span>
                            ))}</>)}
                            {/* ---xxx-activeTheme:{activeTheme}--selectedSeason:{selectedSeason}--seasonOption:{seasonOption}--{seasonOptionIndex} */}
                          <span className='d-inline-block ms-1 text-black d-none' style={{minWidth:'100px',textTransform:'capitalize', fontWeight:'bold'}}>{
                            activeTheme==='maroon'?'Magenta' : activeTheme==='ads' || activeTheme==='brand_ads'?'Advertising' :activeTheme==='thanks' || activeTheme==='brand_thanks'?'Thanks Giving' : activeTheme==='printer'?'Printer Friendly':activeTheme==='brand_christmas'?'Christmas':activeTheme==='brand_blackfriday'?'Black Friday':activeTheme==='brand_diwali'?'Diwali':activeTheme}</span>
                      </div>
                      </div>                     
                  )}
                   <div className='d-inline-block d-md-inline-block mb-2 mb-lg-0' style={{ display: selectedDevice !== 'desktop' ? 'none' : '', cursor: 'pointer', paddingTop:'', display: pathArgument[1] == 'demo' ? 'none' : '' }} onClick={handleCarbonClick}>
                   <div key={isCarbonActive} className={`flex-center bg-white text-black rounded ms-1`} style={{ padding: "0.25em 0.5em" }}>
                   <style>{`.light-green { background-color: #9bfc3f !important; }`}</style>
                   <span className={`${isCarbonActive ? '' : 'opacity-25'}`}>
                   <span style={{ marginRight: "4px" }}>Co2:</span>
                          <span style={{width:'25px', height:'25px'}}>                            
                            <ForestIcon sx={{ fill: 'green !important' }}/>                           
                            </span>
                    </span>
                      </div>
                    </div>      
                    <div className='d-inline-block d-md-inline-block  mb-2 mb-lg-0 py-2' style={{ display: selectedDevice !== 'desktop' ? 'none' : '', paddingTop:'', cursor: 'pointer', display: pathArgument[1] == 'demo' ? 'none' : '' }} onClick={handleRatingClick}>
                          <div key={isRatingActive} className={`flex-center bg-white  text-black rounded ms-1 px-2`} style={{height: '30px'}}>
                          <span className={`${isRatingActive ? '' : 'opacity-25'}`}>
                          <span style={{marginRight:'4px'}}>Show Rating </span>
                          <span class="d-none" style={{width:'25px', height:'25px'}}>
                            <StarsIcon sx={{ fill: 'green !important' }}/>                                                    
                            </span>
                            </span>
                      </div>
                    </div>  

                <div className={`d-inline-block d-md-inline-block ms-1  mb-2 mb-lg-0`}> 
                    <select value={ProductCount} onChange={handleProductCount} style={{ padding: '0.5em 0', borderRadius: '0' }} >                                                                       
                        <option value="">No of Items</option>
                        <option value="1">1</option>                                             
                        <option value="3">3</option>                                           
                        <option value="6">6</option>
                        <option value="10">10</option>                      
                        <option value="25">25</option>                        
                        <option value="50">50</option>
                        <option value="100">100</option>
                        
                    </select>                      
                </div>
                <div className='d-block d-md-inline-block me-1 mb-2 mb-lg-0'>
                <select
                    name="store"
                    value={selectedStore}
                    onChange={handleSelectStore}
                    style={{ padding: '0.5em 0', borderRadius: '0' }}                    
                  >                    
                    <option  value="/">- Store -</option>
                    <option  value="/view/508587d1-347c-46c3-9f45-183db8bc4fbb">Fashion</option>
                    <option value="/view/508587d1-347c-46c3-9f45-283db8bc4fbb">Deichmann</option>
                    <option value="/view/508587d1-347c-46c3-9f45-383db8bc4fbb">H&M</option>
                    <option value="/view/508587d1-347c-46c3-9f45-483db8bc4fbb">LEGO</option>
                    <option value="/view/508587d1-347c-46c3-9f45-583db8bc4fbb">WarHammer</option>
                </select>
              </div>                
              </div>
              </div>
          
        </div>
      <footer className='text-center p-0 py-2 bg-dark hide-in-pdf'>
            <p className='m-0 p-0 text-white'>
              <span className='opacity-75'>&copy; {new Date().getFullYear()}, All rights reserved by </span>
              <a className='text-white opacity-75 hover-opacity-100' href="https://www.invotools.io" target="_blank" rel="noopener noreferrer"><u>www.Invotools.io</u></a></p>
      </footer>
      <OpenModal modalOpen={modalOpen} onClose={() => setmodalOpen(false)} title={modalData.title} content={modalData.content} HtmlPath={modalData.HtmlPath}/>
    </div>
  );
};

export default AppTheme;